import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const PracticeViewSwitch = ({ active }) => (
  <ToggleButtonGroup
    exclusive
    size="small"
    value={active}
    aria-label="Practice"
  >
    <ToggleButton
      value="games"
      component={RouterLink}
      to="/game-cards"
      selected={active === 'games'}
    >
      Games
    </ToggleButton>
    <ToggleButton
      value="moments"
      component={RouterLink}
      to="/moments"
      selected={active === 'moments'}
    >
      Moments
    </ToggleButton>
  </ToggleButtonGroup>
);

export default PracticeViewSwitch;
